export default [function () {

    var ACTION_MSG = {
        saveAndQuoteSubmission: {
            error: {
                title: 'quoteandbind.common.config.FlowConfig.Unable to generate a quote',
                message: 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to calculate a quote.'
            },
            progress: {
                message: 'quoteandbind.common.config.FlowConfig.Calculating Quote...'
            }
        }
    };

    function _quoteFailMessage() {
        return ACTION_MSG.saveAndQuoteSubmission;
    }

    return {
        quoteFailMessage: function quoteFailMessage(resp) {
            return _quoteFailMessage(resp);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/common/util/ActionMessageUtil.js
// module id = 2140
// module chunks = 0